module.exports = __webpack_public_path__ + "static/img/icon5-8.c1cb72f5.png";